import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditService(props) {
  const apiToken = useContext(TokenContext);
  const [validation, setValidation] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenDelete, toggleModalDelete] = useState(false);
  const [dataTemp, setDataTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [announcementsList, setAnnouncementsList] = useState();
  const [serviceId, setServiceId] = useState();
  const [serviceName, setServiceName] = useState();
  const [typeService, setTypeService] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [removableSession, setRemovableSession] = useState();
  let query = useQuery();

  useEffect(() => {
    setLoading(false);
    if (query.get("id")) {
      Repo.getOneServices(apiToken, query.get("id"))
        .then((response) => {
          setData(response.data);
          setServiceId(response.data.id);
          setServiceName(response.data.name);
          Repo.getAnnouncementsByServiceOperator2(
            apiToken,
            response.data.tipoServizio,
          )
            .then((response) => {
              setAnnouncementsList(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
    Repo.getTypeService(apiToken)
      .then((response) => {
        setTypeService(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const sendService = () => {
    setValidation(true);

    let passedValidation = true;

    if (!data.name) passedValidation = false;
    if (!data.description) passedValidation = false;

    if (passedValidation) {
      var dataJson = JSON.stringify(data);
      setDataTemp(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const sendServiceApi = async () => {
    Repo.postUpdateService(apiToken, dataTemp)

      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/categorie";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteTitle = () => {
    Repo.deleteSession(apiToken, removableSession)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const sessions = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-10">
            <h5>
              Interventi associati alla categoria <b>{data.name || ""}</b>
            </h5>
          </div>
          <div className="col-lg-2 text-right">
            <Link
              to={
                "/categorie/visualizza_categoria/nuovo_intervento?id=" +
                serviceId +
                "&name=" +
                serviceName
              }
            >
              <button
                type="button"
                className="btn btn-outline-primary float-right p-2"
              >
                <svg className="icon icon-primary">
                  <use href={`${iconSprite}#it-plus-circle`} />
                </svg>
                <span className="align-middle">Nuovo intervento</span>
              </button>
            </Link>
          </div>
        </div>

        {announcementsList && announcementsList.length > 0 ? (
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Interventi</th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {announcementsList &&
                announcementsList.length > 0 &&
                announcementsList.map((x, index) => (
                  <tr key={index}>
                    <th scope="row">{x.name}</th>
                    <td></td>
                    <td className="text-right">
                      <Link
                        to={
                          "/categorie/visualizza_categoria/dettaglio_intervento?id=" +
                          x.id
                        }
                      >
                        <button
                          className="btn btn-outline-primary p-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Dettaglio"
                        >
                          <svg className="icon icon-primary p-1">
                            <use href={`${iconSprite}#it-search`} />
                          </svg>
                        </button>
                      </Link>
                      <button
                        className="btn btn-outline-danger p-1 ml-1"
                        type="button"
                        onClick={() => {
                          toggleModalDelete(!isOpenDelete);
                          setRemovableSession(x.id);
                        }}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div>Non sono presenti interventi</div>
        )}
      </>
    );
  };

  return (
    <div>
      <h1>Categoria {data.name || ""}</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          In questa sezione è possibile modificare la categoria e aggiungere un
          nuovo intervento associata alla categoria.
        </p>
      </div>
      <div className="row">
        <div className="col-lg-6 select-wrapper">
          <label className="form-label" htmlFor="tipoServizio">
            Tipo di servizio:
          </label>
          <select
            id="tipoServizio"
            disabled={isDisabled}
            name="tipoServizio"
            value={data.tipoServizio || ""}
            onChange={(e) =>
              setData({ ...data, tipoServizio: parseInt(e.target.value, 10) })
            }
            className="form-control custom-textarea mb-3"
          >
            {typeService?.length > 0 &&
              typeService.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.description}
                </option>
              ))}
          </select>

          {validation && !data.tipoServizio && (
            <div className="text-danger error_div">
              Il campo non può essere vuoto!
            </div>
          )}
        </div>
        <div className="col-lg-6">
          <Input
            id="name"
            disabled={isDisabled}
            type="text"
            label="Nome categoria*"
            value={data.name || ""}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            {...(validation &&
              !data.name && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div",
              })}
          />
        </div>

        <div className="col-lg-12 mt-3">
          <textarea
            label="Descrizione"
            disabled={isDisabled}
            id="description"
            rows="3"
            value={data.description || ""}
            onChange={(e) => setData({ ...data, description: e.target.value })}
            {...(validation &&
              !data.description && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div",
              })}
            // disabled={editForce}
          />
        </div>
      </div>{" "}
      {/* fine row*/}
      {isDisabled ? (
        <div className="row my-2">
          <div className="col-lg-12 text-right">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => setIsDisabled(!isDisabled)}
              title="Modifica"
            >
              Modifica
            </button>
          </div>
        </div>
      ) : (
        <div className="row my-2">
          <div className="col-lg-10 text-right">
            <button
              type="button"
              className="btn btn-info text-white"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => setIsDisabled(!isDisabled)}
              title="Indietro"
            >
              Indietro
            </button>
          </div>
          <div className="col-lg-2 text-right">
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => sendService()}
              title="Conferma"
            >
              Conferma
            </button>
          </div>
        </div>
      )}
      <div className="shadow-sm p-3 mb-5 bg-white rounded  mt-5">
        {sessions()}
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica categoria"
        body="Confermi di voler modificare il categoria?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendServiceApi()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModalDelete}
        isOpen={isOpenDelete}
        header="Elimina intervento"
        body="Confermi di voler eliminare questo intervento?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteTitle()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </div>
  );
}

export default EditService;
